import callAPiBase from './base';

const facialApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/facialEntryList',
      method: 'GET',
      useToken: true,
      title: 'Facial Recognition - Get List',
      params,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/facialSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Facial Recognition - Get Settings',
      params,
    }),
  listDailyResume: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reports?reportType=facial_daily_resume',
      method: 'GET',
      useToken: true,
      title: 'Facial Daily Resume - Get List',
      params,
    }),
  listDayDetail: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reports?reportType=facial_day_detail',
      method: 'GET',
      useToken: true,
      title: 'Facial Day Detail - Get List',
      params,
    }),
  getUserStatus: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/facialEntryUserStatus',
      method: 'GET',
      useToken: true,
      title: 'Facial Recognition - Get UserStatus',
      params,
    }),
  getUploadStatus: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/facialUploadStatus',
      method: 'GET',
      useToken: true,
      title: 'Facial Recognition - Get Upload Status',
      params,
    }),
  updateSettings: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/facialSettingsUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Facial Recognition - Update Settings',
      data,
    }),
  updateApprovalStatus: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/facialEntryUpdateApprovalStatus',
      method: 'PATCH',
      useToken: true,
      title: 'Facial Recognition - Update Status',
      data,
    }),
};

export { facialApi };
export default facialApi;
